import { verifyConnection } from '@/services/integrations'

/**
 * One provider call, after OAuth, asking whether the account really works.
 *
 * Folded into the connect flow rather than left to each caller: an ACTIVE
 * connection that cannot be used looks identical to a working one everywhere
 * else in the UI, so anything that forgets to ask shows a green tick over a
 * broken account.
 *
 * A probe that could not run is not a failure — `healthy` stays true and
 * `checked` is null. We only ever claim an account is broken when the provider
 * said so.
 *
 * @param {{ status: string, timedOut?: boolean }} result From pollConnection.
 * @param {string} connectionId
 * @param {string | undefined} workspaceId
 */
export async function confirmConnectionUsable(result, connectionId, workspaceId) {
  if (result?.status !== 'ACTIVE' || !connectionId) return result
  try {
    const health = await verifyConnection({ connectionId, workspaceId })
    return { ...result, ...health }
  } catch {
    // The check itself failing tells us nothing about the account.
    return { ...result, healthy: true, checked: null, detail: null }
  }
}
